import React, { FC, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import SectorContext from '../../context/SectorContext'
import styles from './Dashboard.module.scss'
import { Col } from 'antd'
import Loading from '../../components/Loading'
import { ChartData, DoughnutChart } from './DoughnutChart'
import { ChartSelector } from './ChartSelector'

interface Props {
  mostVisitedBusinessSectors?: Record<string, number>
  sectorsDistribution?: Record<string, number>
}

export const MostVisitedBusinessSectors: FC<Props> = ({
  mostVisitedBusinessSectors,
  sectorsDistribution,
}: Props) => {
  const { t: t_dashboard } = useTranslation('dashboard')
  const { getSectorLabelById } = useContext(SectorContext)
  const { i18n } = useTranslation()

  const [chart, setChart] = useState<string>('top')
  const [dataType, setDataType] = useState<
    Record<string, number> | undefined
  >(mostVisitedBusinessSectors)

  useEffect((): void => {
    setDataType(
      chart === 'top' ? mostVisitedBusinessSectors : sectorsDistribution,
    )
  }, [chart, mostVisitedBusinessSectors, sectorsDistribution])

  const SECTORS_COLORS = [
    '#033059',
    '#12426D',
    '#265C85',
    '#4075A3',
    '#5992C3',
    '#6FAADF',
    '#7EBAF1',
    '#9ACBF8',
  ]

  const getData = (): ChartData => {
    let labels: string[] = []
    let dataset: number[] = []

    if (chart === 'top' && mostVisitedBusinessSectors) {
      labels = Object.keys(mostVisitedBusinessSectors).map((sector) => sector)
      labels.forEach((label): void => {
        let value = mostVisitedBusinessSectors[label]
        dataset.push(value)
      })
    } else if (chart === 'distribution' && sectorsDistribution) {
      labels = Object.keys(sectorsDistribution).map((sector) => sector)
      labels.forEach((label): void => {
        let value = sectorsDistribution[label]
        dataset.push(value)
      })
    }

    return {
      datasets: [
        {
          data: dataset,
          backgroundColor: SECTORS_COLORS.slice(0, dataset.length),
        },
      ],
      labels: labels.map((sector: string) =>
        getSectorLabelById(sector, i18n.language)
      ),
    }
  }

  return (
    <Col sm={24} md={12} className={styles.whiteContainer}>
      <h3>{t_dashboard('business_sectors')}</h3>
      <ChartSelector chart={chart} setChart={setChart} />
      {dataType ? (
        <>
          {Object.keys(dataType).length > 0 ? (
            <DoughnutChart data={getData()} />
          ) : (
            <p>{t_dashboard('not_available')}</p>
          )}
        </>
      ) : (
        <Loading />
      )}
    </Col>
  )
}
